import {
  WithReferralRender
} from "./chunk-CI2MJ5LN.mjs";

// src/internal/components/referral-program-panel/referral-program-panel.tsx
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { useSaasquatch } from "@clara/saasquatch";
import { Flex } from "@clara/ui";
import { isNull } from "@clara/utils";
import { jsx, jsxs } from "react/jsx-runtime";
function SassquatchWidget(props) {
  const { loading, widget } = useSaasquatch(props);
  if (loading || isNull(widget))
    return /* @__PURE__ */ jsxs(Stack, { spacing: 1, marginTop: 3, children: [
      /* @__PURE__ */ jsx(Skeleton, { variant: "text" }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "text" }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular" }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 160 }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: 160 })
    ] });
  return /* @__PURE__ */ jsx(Flex, { className: "squatchembed" });
}
function getReferralProgramSidePanel(props) {
  const panel = {
    children: [
      {
        element: /* @__PURE__ */ jsx(WithReferralRender, { ...props, children: (sassquatch) => /* @__PURE__ */ jsx(SassquatchWidget, { ...sassquatch }) })
      }
    ]
  };
  return panel;
}

export {
  getReferralProgramSidePanel
};
